import {
    CloudUploadOutlined as CloudUploadOutlinedIcon,
    FeedbackOutlined as FeedbackOutlinedIcon,
    PictureAsPdfRounded as PictureAsPdfRoundedIcon
} from '@material-ui/icons';
import {
    Backdrop,
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Fade,
    FormGroup,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import api from '../../../services/api';
import React, { Component } from 'react';
import { isFlagAtiva } from 'lib/configUtils';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { formatData, formatTime, getDateInputValue } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';

class AgendaEscalaFornecedorForm extends Component {
    state = {
        escala: null,
        itens: [],
        isLoading: true,
        isGeneratingReport: false,
        isView: false,
        configPartner: {},
        kminicial: '',
        kmfinal: '',
        fotoKmInicial: null,
        fotoKmFinal: null,
        isImageModalOpen: false,
        imageModalSrc: '',
        imageModalAlt: '',
        openAlert: false,
        messageAlert: '',
        openObsModal: false,
        obsModalTexto: '',
        obsModalTitulo: '',
        openPaxModal: false,
        paxModalTitulo: '',
        paxModalTotal: 0,
        paxModalItens: [],
        paxModalGeral: false
    };

    /* Altera a cor do ícone de upload da foto do KM */
    handleUploadKmIconMouseEnter = (event, hasImage) => {
        if (hasImage) {
            return;
        }

        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna a cor padrão do ícone de upload da foto do KM */
    handleUploadKmIconMouseLeave = (event, hasImage) => {
        if (hasImage) {
            return;
        }

        event.currentTarget.style.color = '#3f51b5';
    };

    /* Altera a cor do ícone de observação */
    handleObsIconMouseEnter = (event, disabled) => {
        if (disabled) {
            return;
        }

        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna a cor padrão do ícone de observação */
    handleObsIconMouseLeave = (event, disabled) => {
        if (disabled) {
            return;
        }

        event.currentTarget.style.color = '#3f51b5';
    };

    /* Abre o modal de observação */
    handleObsIconClick = (item, disabled) => {
        if (disabled) {
            return;
        }

        this.handleOpenObsModal(item);
    };

    /* Altera a cor do ícone de relatório */
    handleReportIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna a cor padrão do ícone de relatório */
    handleReportIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#3f51b5';
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;

        const isView =
            location &&
            location.pathname &&
            location.pathname.includes('/view');

        try {
            await this.loadAgendaEscalaFornecedor(id, isView);
        } catch (error) {
            console.error(
                'Erro ao carregar agenda de escala do fornecedor:',
                error.response?.data || error.message
            );

            this.setState({
                escala: null,
                itens: [],
                isLoading: false
            });

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar detalhes da escala!'
            );
        }
    };

    /* Carrega a agenda de escalas do fornecedor */
    loadAgendaEscalaFornecedor = async (id, isView) => {
        const responseEscala =
            await api.get(`/agendaescalafornecedor/${id}`);

        const escala =
            responseEscala?.data?.data?.[0] || null;

        const configPartnerRaw =
            responseEscala?.data?.configPartner || {};

        const configPartner = Object.fromEntries(
            Object.entries(configPartnerRaw).map(([key, value]) => [
                key,
                typeof value === 'string'
                    ? value.trim()
                    : value
            ])
        );

        const responseItens =
            await api.get(`/agendaescalafornecedor/${id}/itens`);

        const itens =
            responseItens?.data?.data || [];

        this.setState({
            escala,
            itens,
            isLoading: false,
            isView,
            configPartner,
            kminicial:
                escala && escala.kminicial != null
                    ? String(escala.kminicial)
                    : '',
            kmfinal:
                escala && escala.kmfinal != null
                    ? String(escala.kmfinal)
                    : ''
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({
            openAlert: false
        });
    };

    /* Retorna o payload de agenda de escala do fornecedor */
    getPayloadAgendaEscalaFornecedor = () => {
        const {
            kminicial,
            fotoKmInicial,
            kmfinal,
            fotoKmFinal
        } = this.state;

        const formData = new FormData();

        formData.append(
            'kminicial',
            kminicial || ''
        );

        formData.append(
            'kmfinal',
            kmfinal || ''
        );

        if (fotoKmInicial) {
            formData.append(
                'fotokminicial',
                fotoKmInicial
            );
        }

        if (fotoKmFinal) {
            formData.append(
                'fotokmfinal',
                fotoKmFinal
            );
        }

        return formData;
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const {
            escala,
            kminicial,
            kmfinal
        } = this.state;

        const {
            history
        } = this.props;

        if (
            (kminicial && !kmfinal) ||
            (!kminicial && kmfinal)
        ) {
            this.handleOpenAlert(
                'Obrigatório informar o KM inicial e o KM final para salvar!'
            );

            return;
        }

        if (
            kminicial &&
            kmfinal &&
            Number(kmfinal) <= Number(kminicial)
        ) {
            this.handleOpenAlert(
                'KM final deve ser maior que o KM inicial!'
            );

            return;
        }

        try {
            const formData =
                this.getPayloadAgendaEscalaFornecedor();

            await api.put(
                `/agendaescalafornecedor/${escala.coditemescala}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            history.push(
                this.getBaseRoute()
            );
        } catch (error) {
            console.error(
                'Erro ao salvar:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao salvar!'
            );
        }
    };


    /* Converte uma resposta Blob de erro em mensagem */
    getBlobErrorMessage = async (
        blob,
        defaultMessage
    ) => {
        try {
            const blobText =
                await blob.text();

            if (!blobText) {
                return defaultMessage;
            }

            try {
                const parsedMessage =
                    JSON.parse(blobText);

                return (
                    parsedMessage.error ||
                    parsedMessage.message ||
                    parsedMessage.mensagem ||
                    defaultMessage
                );
            } catch (jsonError) {
                return blobText;
            }
        } catch (error) {
            return defaultMessage;
        }
    };

    /* Clicar para gerar e baixar o relatório da escala */
    onClickGenerateReport = async () => {
        const {
            escala,
            isGeneratingReport
        } = this.state;

        const coditemescala =
            Number(escala?.coditemescala);

        if (
            isGeneratingReport ||
            !Number.isInteger(coditemescala) ||
            coditemescala <= 0
        ) {
            return;
        }

        try {
            this.setState({
                isGeneratingReport: true
            });

            const response = await api.post(
                '/partner/generate-report',
                {
                    coditemescala
                },
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
            );

            const contentType =
                response?.headers?.['content-type'] ||
                'application/pdf';

            /*
             * Caso o backend retorne JSON ou texto em uma
             * situação de erro, evita baixar como PDF.
             */
            if (
                contentType.includes('application/json') ||
                contentType.includes('text/')
            ) {
                const message =
                    await this.getBlobErrorMessage(
                        response.data,
                        'Não foi possível gerar o relatório.'
                    );

                throw new Error(message);
            }

            const blob = new Blob(
                [response.data],
                {
                    type: contentType
                }
            );

            if (!blob.size) {
                throw new Error(
                    'O relatório retornado pela API está vazio.'
                );
            }

            const url =
                window.URL.createObjectURL(blob);

            const link =
                document.createElement('a');

            link.href = url;
            link.download =
                `relatorio_transporte_${coditemescala}.pdf`;

            link.style.display = 'none';

            document.body.appendChild(link);

            link.click();

            setTimeout(() => {
                link.remove();

                window.URL.revokeObjectURL(url);
            }, 1000);
        } catch (error) {
            console.error(
                'Não foi possível gerar o relatório de transporte:',
                error.response?.data || error
            );

            let message =
                'Não foi possível gerar o relatório de transporte!';

            if (
                error.response?.data instanceof Blob
            ) {
                message =
                    await this.getBlobErrorMessage(
                        error.response.data,
                        message
                    );
            } else {
                message =
                    error.response?.data?.error ||
                    error.response?.data?.message ||
                    error.response?.data?.mensagem ||
                    error.message ||
                    message;
            }

            this.handleOpenAlert(message);
        } finally {
            this.setState({
                isGeneratingReport: false
            });
        }
    };
    /* Clicar para voltar */
    onClickVoltar = () => {
        this.props.history.push(
            this.getBaseRoute()
        );
    };

    /* Muda os campos KM - somente dígitos */
    handleKmChange = (event) => {
        const {
            name,
            value
        } = event.target;

        this.setState({
            [name]: value.replace(/\D/g, '')
        });
    };

    /* Método para selecionar foto */
    handleFotoChange = (event) => {
        const {
            name,
            files
        } = event.target;

        if (
            files &&
            files[0]
        ) {
            this.setState({
                [name]: files[0]
            });
        }
    };

    /* Abre o modal de visualização da foto */
    handleOpenImageModal = (
        src,
        alt
    ) => {
        if (!src) {
            return;
        }

        this.setState({
            isImageModalOpen: true,
            imageModalSrc: src,
            imageModalAlt: alt || 'Imagem'
        });
    };

    /* Fecha o modal de visualização da foto */
    handleCloseImageModal = () => {
        this.setState({
            isImageModalOpen: false,
            imageModalSrc: '',
            imageModalAlt: ''
        });
    };

    /* Abre o modal de observação */
    handleOpenObsModal = (item) => {
        this.setState({
            openObsModal: true,
            obsModalTexto:
                item && item.obs
                    ? item.obs
                    : '',
            obsModalTitulo:
                item && item.coditemos
                    ? `Observação OS ${item.nroos}`
                    : 'Observação'
        });
    };

    /* Fecha o modal de observação */
    handleCloseObsModal = () => {
        this.setState({
            openObsModal: false,
            obsModalTexto: '',
            obsModalTitulo: ''
        });
    };
    /* Agrupa os itens por hotel */
    groupByHotel = (itens) => {
        const groups = {};

        (itens || []).forEach((item) => {
            const hotel = item.hotel || 'SEM HOTEL';

            if (!groups[hotel]) {
                groups[hotel] = [];
            }

            groups[hotel].push(item);
        });

        return groups;
    };

    /* Retorna a rota base */
    getBaseRoute = () => {
        const { match } = this.props;

        return match.path.startsWith('/admpartner')
            ? '/admpartner/agendaescalafornecedor'
            : '/partner/agendaescalafornecedor';
    };

    /* Abre o modal de passageiros */
    handleOpenPaxModal = async (item = null) => {
        const { escala } = this.state;

        try {
            const params = item
                ? `?coditemos=${item.coditemos}`
                : '';

            const response = await api.get(
                `/agendaescalafornecedor/${escala.coditemescala}/pax${params}`
            );

            const paxModalItens =
                response.data.data || [];

            this.setState({
                openPaxModal: true,
                paxModalItens,
                paxModalTotal: item
                    ? item.totalpax
                    : escala.totalpax,
                paxModalTitulo: item
                    ? `OS ${item.nroos} - ${item.titular}`
                    : `Escala ${escala.coditemescala}`,
                paxModalGeral: !item
            });
        } catch (error) {
            console.error(
                'Erro ao carregar passageiros:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao carregar passageiros!'
            );
        }
    };

    /* Fecha o modal de passageiros */
    handleClosePaxModal = () => {
        this.setState({
            openPaxModal: false,
            paxModalTitulo: '',
            paxModalTotal: 0,
            paxModalItens: [],
            paxModalGeral: false
        });
    };

    /* Agrupa os passageiros por OS */
    groupPaxByOS = (paxModalItens) => {
        const groups = {};

        (paxModalItens || []).forEach((pax) => {
            const key =
                pax.coditemos ||
                pax.nroos;

            if (!groups[key]) {
                groups[key] = {
                    coditemos: pax.coditemos,
                    nroos: pax.nroos,
                    titular: pax.titular,
                    itens: []
                };
            }

            groups[key].itens.push(pax);
        });

        return Object.values(groups);
    };

    render() {
        const {
            configPartner,
            escala,
            fotoKmFinal,
            fotoKmInicial,
            imageModalAlt,
            imageModalSrc,
            isGeneratingReport,
            isImageModalOpen,
            isLoading,
            isView,
            itens,
            kmfinal,
            kminicial,
            messageAlert,
            obsModalTexto,
            obsModalTitulo,
            openAlert,
            openObsModal,
            openPaxModal,
            paxModalItens,
            paxModalGeral,
            paxModalTitulo,
            paxModalTotal
        } = this.state;

        if (
            isLoading ||
            !escala
        ) {
            return (
                <div style={{ padding: 30 }}>
                    <Typography variant="body1">
                        Carregando...
                    </Typography>
                </div>
            );
        }

        const grupos =
            this.groupByHotel(itens);

        const hoteisOrdenados =
            Object
                .keys(grupos)
                .sort(
                    (a, b) =>
                        a.localeCompare(b)
                );

        const fotoKmInicialSrc =
            fotoKmInicial
                ? URL.createObjectURL(fotoKmInicial)
                : escala &&
                    escala.fotokminicial
                    ? `data:image/jpeg;base64,${escala.fotokminicial}`
                    : '';

        const fotoKmFinalSrc =
            fotoKmFinal
                ? URL.createObjectURL(fotoKmFinal)
                : escala &&
                    escala.fotokmfinal
                    ? `data:image/jpeg;base64,${escala.fotokmfinal}`
                    : '';

        const gruposPax =
            this.groupPaxByOS(paxModalItens);

        const informaKmIniFim =
            isFlagAtiva(
                configPartner,
                'informakminifim'
            );

        const registraFotoKm =
            isFlagAtiva(
                configPartner,
                'registrafotokm'
            );

        const informaDataHoraFinal =
            isFlagAtiva(
                configPartner,
                'informadatahsfinal'
            );

        return (
            <div
                style={{
                    marginLeft: 30,
                    marginTop: 30,
                    marginRight: 30
                }}
            >
                <Card>
                    <CardContent>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            style={{
                                flexWrap: 'wrap',
                                gap: 12
                            }}
                        >
                            <Typography variant="h5">
                                Escala {escala.coditemescala}
                            </Typography>

                            <Box
                                display="flex"
                                alignItems="center"
                                flexWrap="wrap"
                                style={{
                                    gap: 10
                                }}
                            >
                                <Tooltip
                                    title={
                                        isGeneratingReport
                                            ? 'Gerando relatório...'
                                            : 'Baixar relatório'
                                    }
                                >
                                    <PictureAsPdfRoundedIcon
                                        onClick={
                                            this.onClickGenerateReport
                                        }
                                        onMouseEnter={(event) => {
                                            if (
                                                !isGeneratingReport
                                            ) {
                                                this.handleReportIconMouseEnter(
                                                    event
                                                );
                                            }
                                        }}
                                        onMouseLeave={(event) => {
                                            if (
                                                !isGeneratingReport
                                            ) {
                                                this.handleReportIconMouseLeave(
                                                    event
                                                );
                                            }
                                        }}
                                        style={{
                                            cursor:
                                                isGeneratingReport
                                                    ? 'not-allowed'
                                                    : 'pointer',
                                            color:
                                                isGeneratingReport
                                                    ? '#9e9e9e'
                                                    : '#3f51b5',
                                            fontSize: 26,
                                            opacity:
                                                isGeneratingReport
                                                    ? 0.7
                                                    : 1,
                                            pointerEvents:
                                                isGeneratingReport
                                                    ? 'none'
                                                    : 'auto'
                                        }}
                                    />
                                </Tooltip>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={
                                        this.onClickVoltar
                                    }
                                >
                                    Voltar
                                </Button>

                                {!isView &&
                                    (
                                        informaKmIniFim ||
                                        registraFotoKm
                                    ) && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={
                                                this.onClickSave
                                            }
                                        >
                                            Salvar
                                        </Button>
                                    )}
                            </Box>
                        </Box>

                        <Divider
                            style={{
                                marginTop: 12,
                                marginBottom: 12
                            }}
                        />

                        <Box
                            display="flex"
                            justifyContent="space-between"
                            style={{
                                flexWrap: 'wrap',
                                gap: 24
                            }}
                        >
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="flex-start"
                                justifyContent="space-between"
                                style={{
                                    gap: 12,
                                    minHeight: 82
                                }}
                            >
                                <Box
                                    style={{
                                        textAlign: 'left'
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Data
                                    </Typography>

                                    <Typography variant="body1">
                                        {formatData(
                                            escala.dataservico
                                        )}
                                    </Typography>
                                </Box>

                                <Box
                                    style={{
                                        textAlign: 'left'
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Serviço
                                    </Typography>

                                    <Typography variant="body1">
                                        {escala.descservico}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="flex-end"
                                justifyContent="space-between"
                                style={{
                                    gap: 12,
                                    minHeight: 82
                                }}
                            >
                                <Box
                                    style={{
                                        textAlign: 'right'
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Total Pax
                                    </Typography>

                                    <Typography variant="body1">
                                        <span
                                            onClick={() =>
                                                this.handleOpenPaxModal()
                                            }
                                            style={{
                                                cursor: 'pointer',
                                                color: '#3f51b5',
                                                fontWeight: 500
                                            }}
                                        >
                                            {escala.totalpax}
                                        </span>
                                    </Typography>
                                </Box>

                                <Box
                                    style={{
                                        textAlign: 'right'
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Hora Serviço
                                    </Typography>

                                    <Typography variant="body1">
                                        {formatTime(
                                            escala.horaservico
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Divider
                            style={{
                                marginTop: 8,
                                marginBottom: 12
                            }}
                        />

                        {/* Bloco configurações Partner */}
                        {
                            (
                                informaKmIniFim ||
                                registraFotoKm ||
                                informaDataHoraFinal
                            ) && (
                                <React.Fragment>
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        style={{
                                            flexWrap: 'wrap',
                                            gap: 24
                                        }}
                                    >
                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            style={{
                                                gap: 12
                                            }}
                                        >
                                            {informaKmIniFim && (
                                                <Box
                                                    display="flex"
                                                    flexWrap="wrap"
                                                    alignItems="flex-end"
                                                    style={{
                                                        gap: 8
                                                    }}
                                                >
                                                    <TextField
                                                        label="KM inicial"
                                                        name="kminicial"
                                                        value={
                                                            kminicial
                                                        }
                                                        onChange={
                                                            this.handleKmChange
                                                        }
                                                        disabled={
                                                            isView
                                                        }
                                                        variant="outlined"
                                                        inputProps={{
                                                            inputMode:
                                                                'numeric',
                                                            pattern:
                                                                '[0-9]*',
                                                            maxLength: 10
                                                        }}
                                                        style={{
                                                            minWidth: 120,
                                                            flex:
                                                                '0 1 120px',
                                                            backgroundColor:
                                                                isView
                                                                    ? '#f2f2f2'
                                                                    : 'transparent'
                                                        }}
                                                    />

                                                    {registraFotoKm && (
                                                        <Box
                                                            display="flex"
                                                            flexDirection="column"
                                                            alignItems="center"
                                                        >
                                                            <Tooltip
                                                                title={
                                                                    isView
                                                                        ? 'Foto KM inicial'
                                                                        : 'Inserir foto KM inicial'
                                                                }
                                                            >
                                                                <label>
                                                                    <CloudUploadOutlinedIcon
                                                                        onClick={(event) => {
                                                                            if (
                                                                                isView
                                                                            ) {
                                                                                event.preventDefault();

                                                                                this.handleOpenImageModal(
                                                                                    fotoKmInicialSrc,
                                                                                    'Foto KM inicial'
                                                                                );
                                                                            }
                                                                        }}
                                                                        onMouseEnter={(event) =>
                                                                            this.handleUploadKmIconMouseEnter(
                                                                                event,
                                                                                !!fotoKmInicialSrc
                                                                            )
                                                                        }
                                                                        onMouseLeave={(event) =>
                                                                            this.handleUploadKmIconMouseLeave(
                                                                                event,
                                                                                !!fotoKmInicialSrc
                                                                            )
                                                                        }
                                                                        style={{
                                                                            cursor:
                                                                                isView &&
                                                                                    !fotoKmInicialSrc
                                                                                    ? 'default'
                                                                                    : 'pointer',
                                                                            fontSize: 26,
                                                                            color:
                                                                                fotoKmInicialSrc
                                                                                    ? '#43a047'
                                                                                    : '#3f51b5'
                                                                        }}
                                                                    />

                                                                    {!isView && (
                                                                        <input
                                                                            type="file"
                                                                            name="fotoKmInicial"
                                                                            accept="image/*"
                                                                            hidden
                                                                            onChange={
                                                                                this.handleFotoChange
                                                                            }
                                                                        />
                                                                    )}
                                                                </label>
                                                            </Tooltip>

                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={
                                                                    !fotoKmInicialSrc
                                                                }
                                                                onClick={() =>
                                                                    this.handleOpenImageModal(
                                                                        fotoKmInicialSrc,
                                                                        'Foto KM inicial'
                                                                    )
                                                                }
                                                                style={{
                                                                    fontSize: 10,
                                                                    color:
                                                                        fotoKmInicialSrc
                                                                            ? '#2e7d32'
                                                                            : undefined,
                                                                    borderColor:
                                                                        fotoKmInicialSrc
                                                                            ? '#66bb6a'
                                                                            : undefined,
                                                                    backgroundColor:
                                                                        fotoKmInicialSrc
                                                                            ? '#edf7ed'
                                                                            : undefined
                                                                }}
                                                            >
                                                                Visualizar
                                                            </Button>
                                                        </Box>
                                                    )}
                                                </Box>
                                            )}

                                            {informaKmIniFim && (
                                                <Box
                                                    display="flex"
                                                    flexWrap="wrap"
                                                    alignItems="flex-end"
                                                    style={{
                                                        gap: 8
                                                    }}
                                                >
                                                    <TextField
                                                        label="KM final"
                                                        name="kmfinal"
                                                        value={
                                                            kmfinal
                                                        }
                                                        onChange={
                                                            this.handleKmChange
                                                        }
                                                        disabled={
                                                            isView
                                                        }
                                                        variant="outlined"
                                                        inputProps={{
                                                            inputMode:
                                                                'numeric',
                                                            pattern:
                                                                '[0-9]*',
                                                            maxLength: 10
                                                        }}
                                                        style={{
                                                            minWidth: 120,
                                                            flex:
                                                                '0 1 120px',
                                                            backgroundColor:
                                                                isView
                                                                    ? '#f2f2f2'
                                                                    : 'transparent'
                                                        }}
                                                    />

                                                    {registraFotoKm && (
                                                        <Box
                                                            display="flex"
                                                            flexDirection="column"
                                                            alignItems="center"
                                                        >
                                                            <Tooltip
                                                                title={
                                                                    isView
                                                                        ? 'Foto KM final'
                                                                        : 'Inserir foto KM final'
                                                                }
                                                            >
                                                                <label>
                                                                    <CloudUploadOutlinedIcon
                                                                        onClick={(event) => {
                                                                            if (
                                                                                isView
                                                                            ) {
                                                                                event.preventDefault();

                                                                                this.handleOpenImageModal(
                                                                                    fotoKmFinalSrc,
                                                                                    'Foto KM final'
                                                                                );
                                                                            }
                                                                        }}
                                                                        onMouseEnter={(event) =>
                                                                            this.handleUploadKmIconMouseEnter(
                                                                                event,
                                                                                !!fotoKmFinalSrc
                                                                            )
                                                                        }
                                                                        onMouseLeave={(event) =>
                                                                            this.handleUploadKmIconMouseLeave(
                                                                                event,
                                                                                !!fotoKmFinalSrc
                                                                            )
                                                                        }
                                                                        style={{
                                                                            cursor:
                                                                                isView &&
                                                                                    !fotoKmFinalSrc
                                                                                    ? 'default'
                                                                                    : 'pointer',
                                                                            fontSize: 26,
                                                                            color:
                                                                                fotoKmFinalSrc
                                                                                    ? '#43a047'
                                                                                    : '#3f51b5'
                                                                        }}
                                                                    />

                                                                    {!isView && (
                                                                        <input
                                                                            type="file"
                                                                            name="fotoKmFinal"
                                                                            accept="image/*"
                                                                            hidden
                                                                            onChange={
                                                                                this.handleFotoChange
                                                                            }
                                                                        />
                                                                    )}
                                                                </label>
                                                            </Tooltip>

                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                disabled={
                                                                    !fotoKmFinalSrc
                                                                }
                                                                onClick={() =>
                                                                    this.handleOpenImageModal(
                                                                        fotoKmFinalSrc,
                                                                        'Foto KM final'
                                                                    )
                                                                }
                                                                style={{
                                                                    fontSize: 10,
                                                                    color:
                                                                        fotoKmFinalSrc
                                                                            ? '#2e7d32'
                                                                            : undefined,
                                                                    borderColor:
                                                                        fotoKmFinalSrc
                                                                            ? '#66bb6a'
                                                                            : undefined,
                                                                    backgroundColor:
                                                                        fotoKmFinalSrc
                                                                            ? '#edf7ed'
                                                                            : undefined
                                                                }}
                                                            >
                                                                Visualizar
                                                            </Button>
                                                        </Box>
                                                    )}
                                                </Box>
                                            )}
                                        </Box>

                                        <Box
                                            display="flex"
                                            flexDirection="column"
                                            justifyContent="space-between"
                                            style={{
                                                gap: 12,
                                                minHeight: 116
                                            }}
                                        >
                                            {informaDataHoraFinal && (
                                                <TextField
                                                    label="Data final serviço"
                                                    type="date"
                                                    value={
                                                        getDateInputValue(
                                                            escala?.datafimservico
                                                        )
                                                    }
                                                    variant="outlined"
                                                    disabled
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    style={{
                                                        width: 150
                                                    }}
                                                />
                                            )}

                                            {informaDataHoraFinal && (
                                                <TextField
                                                    label="Hora final serviço"
                                                    type="time"
                                                    value={
                                                        formatTime(
                                                            escala?.horafimservico
                                                        )
                                                    }
                                                    variant="outlined"
                                                    disabled
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    style={{
                                                        width: 150
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Box>

                                    <br />

                                    <Divider
                                        style={{
                                            marginTop: 8,
                                            marginBottom: 12
                                        }}
                                    />
                                </React.Fragment>
                            )
                        }
                        <Typography variant="h6">
                            Ordens de Serviço Escaladas
                        </Typography>

                        <br />

                        {hoteisOrdenados.length === 0 ? (
                            <Typography variant="body2">
                                Nenhuma OS encontrada para essa escala
                            </Typography>
                        ) : (
                            hoteisOrdenados.map((hotel) => (
                                <Box
                                    key={hotel}
                                    style={{
                                        marginBottom: 18
                                    }}
                                >
                                    <Paper>
                                        <PerfectScrollBar>
                                            <div
                                                style={{
                                                    minWidth: 1200
                                                }}
                                            >
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                OS
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Titular
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Total Pax
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Hotel
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Local Origem
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Local Destino
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Hora Apresentação
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Observação
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {grupos[hotel].map(
                                                            (item) => (
                                                                <TableRow
                                                                    hover
                                                                    key={
                                                                        item.nroos
                                                                    }
                                                                >
                                                                    <TableCell align="center">
                                                                        {
                                                                            item.nroos
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {
                                                                            item.titular
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        <span
                                                                            onClick={() =>
                                                                                this.handleOpenPaxModal(
                                                                                    item
                                                                                )
                                                                            }
                                                                            style={{
                                                                                cursor:
                                                                                    'pointer',
                                                                                color:
                                                                                    '#3f51b5',
                                                                                fontWeight: 500
                                                                            }}
                                                                        >
                                                                            {
                                                                                item.totalpax
                                                                            }
                                                                        </span>
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {
                                                                            item.hotel
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {
                                                                            item.localorigem
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {
                                                                            item.localdestino
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {formatTime(
                                                                            item.horaapresentacao
                                                                        )}
                                                                    </TableCell>

                                                                    <TableCell align="center">
                                                                        {(() => {
                                                                            const semObs =
                                                                                !item.obs ||
                                                                                item.obs.trim() ===
                                                                                '';

                                                                            return (
                                                                                <Tooltip
                                                                                    title={
                                                                                        semObs
                                                                                            ? ''
                                                                                            : 'Observação'
                                                                                    }
                                                                                >
                                                                                    <span>
                                                                                        <FeedbackOutlinedIcon
                                                                                            onMouseEnter={(
                                                                                                event
                                                                                            ) =>
                                                                                                this.handleObsIconMouseEnter(
                                                                                                    event,
                                                                                                    semObs
                                                                                                )
                                                                                            }
                                                                                            onMouseLeave={(
                                                                                                event
                                                                                            ) =>
                                                                                                this.handleObsIconMouseLeave(
                                                                                                    event,
                                                                                                    semObs
                                                                                                )
                                                                                            }
                                                                                            onClick={() =>
                                                                                                this.handleObsIconClick(
                                                                                                    item,
                                                                                                    semObs
                                                                                                )
                                                                                            }
                                                                                            style={{
                                                                                                cursor:
                                                                                                    semObs
                                                                                                        ? 'default'
                                                                                                        : 'pointer',
                                                                                                color:
                                                                                                    semObs
                                                                                                        ? '#bdbdbd'
                                                                                                        : '#3f51b5'
                                                                                            }}
                                                                                        />
                                                                                    </span>
                                                                                </Tooltip>
                                                                            );
                                                                        })()}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </PerfectScrollBar>
                                    </Paper>
                                </Box>
                            ))
                        )}
                    </CardContent>
                </Card>

                <Dialog
                    open={openObsModal}
                    onClose={
                        this.handleCloseObsModal
                    }
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        {obsModalTitulo}
                    </DialogTitle>

                    <DialogContent
                        style={{
                            paddingBottom: 24
                        }}
                    >
                        <FormGroup
                            style={{
                                marginBottom: 8
                            }}
                        >
                            <textarea
                                value={obsModalTexto}
                                readOnly
                                style={{
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    height: 220,
                                    padding: 12,
                                    border:
                                        '1px solid #ccc',
                                    borderRadius: 6,
                                    fontFamily:
                                        'Calibri, sans-serif',
                                    resize: 'none',
                                    overflowY: 'auto',
                                    cursor: 'default'
                                }}
                            />
                        </FormGroup>
                    </DialogContent>
                </Dialog>

                <Modal
                    open={isImageModalOpen}
                    onClose={
                        this.handleCloseImageModal
                    }
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500
                    }}
                >
                    <Fade in={isImageModalOpen}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform:
                                    'translate(-50%, -50%)',
                                width: '90vw',
                                height: '85vh',
                                maxWidth: 1040,
                                maxHeight: 585,
                                backgroundColor:
                                    'transparent',
                                borderRadius: 12,
                                boxShadow: 'none',
                                border: 'none',
                                outline: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 0
                            }}
                        >
                            <img
                                src={imageModalSrc}
                                alt={imageModalAlt}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    borderRadius: 8,
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </Fade>
                </Modal>

                <Dialog
                    open={openPaxModal}
                    onClose={
                        this.handleClosePaxModal
                    }
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        <span
                            style={{
                                color: paxModalGeral
                                    ? '#000000'
                                    : '#3f51b5'
                            }}
                        >
                            {paxModalTitulo} - Total Pax:{' '}
                            {paxModalTotal}
                        </span>
                    </DialogTitle>

                    <DialogContent
                        style={{
                            paddingBottom: 24
                        }}
                    >
                        {paxModalItens.length === 0 && (
                            <Typography
                                variant="body2"
                                align="center"
                            >
                                Nenhum passageiro encontrado
                            </Typography>
                        )}

                        {paxModalGeral ? (
                            gruposPax.map((grupo) => (
                                <Box
                                    key={
                                        grupo.coditemos ||
                                        grupo.nroos
                                    }
                                    style={{
                                        marginBottom: 24
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        style={{
                                            color: '#3f51b5',
                                            fontWeight: 500,
                                            marginBottom: 8
                                        }}
                                    >
                                        OS {grupo.nroos} -{' '}
                                        {grupo.titular} - Total Pax:{' '}
                                        {grupo.itens.length}
                                    </Typography>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Passageiro
                                                </TableCell>

                                                <TableCell align="center">
                                                    Tipo
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {grupo.itens.map(
                                                (
                                                    pax,
                                                    index
                                                ) => (
                                                    <TableRow
                                                        key={`${pax.coditemos}-${index}`}
                                                    >
                                                        <TableCell>
                                                            {
                                                                pax.nome
                                                            }
                                                        </TableCell>

                                                        <TableCell align="center">
                                                            {
                                                                pax.tipo
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            ))
                        ) : (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Passageiro
                                        </TableCell>

                                        <TableCell align="center">
                                            Tipo
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paxModalItens.map(
                                        (
                                            pax,
                                            index
                                        ) => (
                                            <TableRow
                                                key={`${pax.coditemos}-${index}`}
                                            >
                                                <TableCell>
                                                    {
                                                        pax.nome
                                                    }
                                                </TableCell>

                                                <TableCell align="center">
                                                    {
                                                        pax.tipo
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    )}
                                </TableBody>
                            </Table>
                        )}
                    </DialogContent>
                </Dialog>
                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default AgendaEscalaFornecedorForm;